// extracted by mini-css-extract-plugin
export default {"dialog":"EditNotesDialog_dialog__VQHJE"};